// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"8f8bccdb","211":"bb151851","212":"74002099","609":"b862a274","804":"960a266c"}[chunkId] + ".chunk.js";
};